import { render, staticRenderFns } from "./HeaderInformationNavigationWrktp.vue?vue&type=template&id=a916b038&scoped=true"
import script from "./HeaderInformationNavigationWrktp.vue?vue&type=script&lang=ts"
export * from "./HeaderInformationNavigationWrktp.vue?vue&type=script&lang=ts"
import style0 from "./HeaderInformationNavigationWrktp.vue?vue&type=style&index=0&id=a916b038&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a916b038",
  null
  
)

export default component.exports